import React from "react";

const PodcastOutline = () => {
      return (
            <div className="solarpodcast-outline">
                  <img className="headphone-icon" alt="" src="/vector.svg" />
            </div>
      );
};

export default PodcastOutline;